import {
  MAIN_MENU_ITEMS_RAW,
  SETTINGS_MENU_ITEMS_RAW,
  OEE_MENU_ITEMS_RAW,
  SPARE_PARTS_INVENTORY_MENU_ITEMS_RAW,
  RCA_MENU_ITEMS_RAW,
  CAPA_MENU_ITEMS_RAW,
  SAFETY_OBSERVATION_MENU_ITEMS_RAW,
  INCIDENT_MENU_ITEMS_RAW,
  HAZARD_MENU_ITEMS_RAW,
  REPORTS_DETAIL_ITEMS_RAW,
  PM_MENU_ITEMS_RAW,
  WORK_PERMIT_MENU_ITEMS_RAW,
} from "./navConfig";

/**
 * All navigable module keys for Super Admin to configure home "Overview" tiles.
 * Order: same grouping as the app nav / command palette (not feature-gated here).
 */
export function getWorkspaceOverviewCatalog() {
  const seen = new Set();
  const rows = [];

  const push = (items, group) => {
    (items || []).forEach((item) => {
      if (!item?.key || seen.has(item.key)) return;
      seen.add(item.key);
      rows.push({
        id: item.key,
        label: item.label,
        group,
        path: item.path,
      });
    });
  };

  push(MAIN_MENU_ITEMS_RAW, "Overview");
  push(OEE_MENU_ITEMS_RAW, "OEE");
  push(RCA_MENU_ITEMS_RAW, "RCA");
  push(CAPA_MENU_ITEMS_RAW, "CAPA");
  push(HAZARD_MENU_ITEMS_RAW, "Hazard Reporting");
  push(SAFETY_OBSERVATION_MENU_ITEMS_RAW, "Safety Observation");
  push(INCIDENT_MENU_ITEMS_RAW, "Incident");
  rows.push({
    id: "reports-hub",
    label: "Reports",
    group: "Reports",
    path: "/home/reports",
  });
  seen.add("reports-hub");
  push(REPORTS_DETAIL_ITEMS_RAW, "Report pages");
  push(PM_MENU_ITEMS_RAW, "Machine Health");
  push(WORK_PERMIT_MENU_ITEMS_RAW, "Work Permits");
  push(SPARE_PARTS_INVENTORY_MENU_ITEMS_RAW, "Spare parts & Inventory");
  push(SETTINGS_MENU_ITEMS_RAW, "Settings");

  return rows;
}
